export default __webpack_public_path__ + "static/media/flop-types_0003_thumb.3a6c198e.jpg";